import { render } from "./questioneditorbp.vue?vue&type=template&id=3c12781f"
import script from "./questioneditorbp.vue?vue&type=script&lang=js"
export * from "./questioneditorbp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__